import {Container} from 'pixi.js';
import {CoreDI, DeviceType, inject, injectable, IService, ScreenManager, SystemComponentType} from '@gongxigames/framework/core';
import {ScaleParameters} from '@gongxigames/framework/slot/utils';
import {GameConfig, IReelsScaleService, MobileReelsScaleParameters} from '@gongxigames/framework/slot/types';
import {defaultReelsScaleConfig} from '@gongxigames/framework/slot/configs/defaultReelsScaleConfig';
import {DI} from '@gongxigames/framework/slot/configs/DI';
import {ScaleUtils} from '@gongxigames/framework/slot/utils/ScaleUtils';

@injectable()
export class ReelsScaleService implements IReelsScaleService, IService {
    public static NAME: symbol = DI.ReelsScaleService;
    public type: SystemComponentType = 'service';

    @inject(CoreDI.GameConfig)
    protected readonly _gameConfig!: GameConfig;

    @inject(CoreDI.ScreenManager)
    protected readonly _screenManager!: ScreenManager;

    protected _scaleUtils!: ScaleUtils;

    public init(): void {
        this._scaleUtils = new ScaleUtils(
            {reelsScaleConfig: defaultReelsScaleConfig},
            this._screenManager.mobilePortraitModeScale,
            this._gameConfig.viewport.mobile.width
        );

        if (this._gameConfig.reelsScaleConfig) {
            this._scaleUtils.applyNewScaleConfig('reelsScaleConfig', this._gameConfig.reelsScaleConfig);
        }
    }

    public getMobileAllScaleParameters(): MobileReelsScaleParameters {
        const params = this._scaleUtils.getAllScaleParameters('reelsScaleConfig');

        return {
            ...params,
            reelsMobilePortraitModeParams: params.portrait,
            reelsMobileLandscapeModeParams: params.landscape
        };
    }

    public reelsMobileLandscapeScale(container?: Container): void {
        container && this._scaleUtils.scaleByTargetPlatform('reelsScaleConfig', DeviceType.MOBILE, true, container);
    }

    public reelsMobilePortraitScale(container?: Container): void {
        container && this._scaleUtils.scaleByTargetPlatform('reelsScaleConfig', DeviceType.MOBILE, false, container);
    }

    public reelsDesktopScale(container?: Container): void {
        container && this._scaleUtils.scaleByTargetPlatform('reelsScaleConfig', DeviceType.DESKTOP, false, container);
    }

    public scaleByCurrentScreenOrientation(...containers: Container[]): void {
        this._scaleUtils.scaleByTargetPlatform('reelsScaleConfig', DeviceType.MOBILE, this._screenManager.isLandscapeOrientation(), ...containers);
    }

    public getMobileReelsParameters(): ScaleParameters {
        const allScaleParameters = this._scaleUtils.getAllScaleParameters('reelsScaleConfig');

        return this._screenManager.isLandscapeOrientation() ? allScaleParameters.landscape : allScaleParameters.portrait;
    }
}
